import { createSlice } from '@reduxjs/toolkit';
import { LoquateInitial, LoquateInitialLookupItems, LoquatePopulatedLookupItem } from '../../types/loquate';
import {
  getFormattedStreetFromLoquate,
  getFormattedHouseNameFromLoquate,
  getFormattedHouseNumberFromLoquate,
} from '../../utils/preapproval/getFormattedAddress';

const initialState: LoquateInitial = {
  error: null,
  Items: null,
  PopulatedItems: null,
  PropertyPalItem: null,
};

interface SetData {
  payload: LoquateInitialLookupItems[] | null;
}

interface SetPopulated {
  payload: LoquatePopulatedLookupItem[] | null;
}

export const loquateSlice = createSlice({
  name: 'loquate',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      return state;
    },
    setInitialLookupData: (state, action: SetData) => {
      state.Items = action.payload;
    },
    setPopulatedLookupData: (state, action: SetPopulated) => {
      const payload = action.payload;
      if (payload) {
        state.PopulatedItems = payload;
        const details = payload[0];
        const addressLine1 = getFormattedStreetFromLoquate(details);
        const houseNumber = getFormattedHouseNumberFromLoquate(details);
        const houseName = getFormattedHouseNameFromLoquate(details);
        state.PropertyPalItem = {
          flat: details.SubBuilding,
          houseNumber,
          houseName,
          addressLine1,
          town: details.City,
          county: details.ProvinceName,
          postcode: details.PostalCode,
          years: null,
          months: null,
          completed: false,
        };
      }
    },
    clearPopulatedItem: (state) => {
      state.PopulatedItems = null;
      state.PropertyPalItem = null;
    },
  },
});

export const { setError, setInitialLookupData, setPopulatedLookupData, clearPopulatedItem } = loquateSlice.actions;
export default loquateSlice.reducer;
